const stateTicket = {
  TICKET_STATE_PENDING: "در حال انتظار",
  TICKET_STATE_ANSWERED: "پاسخ داده شده",
  TICKET_STATE_CLOSED: "بسته شده",
};

export default {
  stateTicket,
};
